module.exports = __webpack_public_path__ + "img/sass.ffb9976a.png";